const getAttributeGlobals = (id) => {
    const element = document.getElementById(id);
    const data = element && element.getAttribute('data-globals') || null;
    return data ? JSON.parse(data) : undefined;
};

const globals = getAttributeGlobals('tyroolaGlobals');
const translations = getAttributeGlobals('translationsGlobals');
const initialFluxStateGlobals = getAttributeGlobals('initialFluxStateGlobals');

// const TYROOLA = TYROOLA || {};
window.TYROOLA = window.TYROOLA || {};
TYROOLA.globals = globals || {};
TYROOLA.translations = translations || {};
TYROOLA.initialFluxStates = initialFluxStateGlobals || {};

